import { addFilter } from '@wordpress/hooks';

import { NAMESPACE } from '../../settings';

import addFeaturedImageVariationAttribute from './filters/addFeaturedImageVariationAttribute';
import withFeaturedImageVariationBlockControls from './filters/withFeaturedImageVariationBlockControls';

const featureFlags = window.mediaPressMediaBlocks?.featureFlags || {};

if (featureFlags.featuredImageVariations) {
  // Add featured image variation attribute to blocks that should support it
  addFilter(
    'blocks.registerBlockType',
    `${NAMESPACE}/add-featured-image-block-variation-attribute`,
    addFeaturedImageVariationAttribute,
  );

  // Add featured image variation controls to certain blocks
  addFilter(
    'editor.BlockEdit',
    `${NAMESPACE}/with-featured-image-variation-block-controls`,
    withFeaturedImageVariationBlockControls,
  );
}
